import { takeLatest, put } from "redux-saga/effects";

import { FETCH_DATA_ROOMLIST_REQUEST, SAVE_DATA_ROOMLIST_REQUEST } from "./constants";
import { fetchRoomListSuccess, saveDataRoomListSuccess } from "./actions";
import * as Api from '../../../services';

function* fetchRoomList() {
  const { data } = yield Api.getRoomListAPI();
  yield put(fetchRoomListSuccess(data));
}

function* saveDataRoomList(payload) {
  localStorage.setItem('_dataRegisterRoom', JSON.stringify(payload.payload));
  yield put(saveDataRoomListSuccess(payload.payload));
}

export function* saga() {
  yield takeLatest(FETCH_DATA_ROOMLIST_REQUEST, fetchRoomList);
  yield takeLatest(SAVE_DATA_ROOMLIST_REQUEST, saveDataRoomList);
}
